import { Link } from "react-router-dom";
import { Lock, Play, Clock } from "lucide-react";

export default function PosterCard({ item, locked }) {
  const isComing = !!item.coming_soon;
  const isLocked = !isComing && locked && item.type !== "trailer";

  // Coming-soon posters are not clickable to watch; they open the detail page only,
  // which itself shows the "Coming soon" screen instead of a player.
  const linkTo = `/watch/${item.id}`;

  return (
    <Link
      to={linkTo}
      data-testid={`poster-${item.id}`}
      data-coming-soon={isComing ? "true" : undefined}
      className="poster-card relative block w-[180px] md:w-[220px] flex-shrink-0 rounded-lg overflow-hidden group bg-[#141419] border border-white/5"
    >
      <div className="aspect-[2/3] relative">
        <img
          src={item.poster_url}
          alt={item.title}
          className="w-full h-full object-cover"
          loading="lazy"
        />

        {/* Subtle dimming overlay for coming-soon */}
        {isComing && (
          <div className="absolute inset-0 bg-black/35 group-hover:bg-black/20 transition-colors duration-300" />
        )}

        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="font-display font-bold text-sm text-white truncate">{item.title}</div>
          <div className="text-[11px] text-gray-300 uppercase tracking-wider mt-0.5">
            {item.genre}{item.year ? ` · ${item.year}` : ""}
          </div>
        </div>

        {/* Top-right badge */}
        {isComing ? (
          <div
            data-testid={`coming-soon-badge-${item.id}`}
            className="absolute top-2 left-2 inline-flex items-center gap-1 rounded-full bg-[#FFD700] text-black px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.15em] shadow-lg"
          >
            <Clock className="w-3 h-3" /> Coming Soon
          </div>
        ) : isLocked ? (
          <div className="absolute top-2 right-2 bg-black/70 backdrop-blur-md rounded-full p-1.5 border border-white/10">
            <Lock className="w-3.5 h-3.5 text-[#FFD700]" />
          </div>
        ) : (
          <div className="absolute top-2 right-2 bg-black/70 backdrop-blur-md rounded-full p-1.5 border border-white/10 opacity-0 group-hover:opacity-100 transition">
            <Play className="w-3.5 h-3.5 text-white fill-white" />
          </div>
        )}
      </div>
    </Link>
  );
}
